
import * as moment from 'moment';

export interface IAssociationModel {
  id?: number;
  name: string;
  is_enabled: boolean;
  about: string;
  logo: string;
  created: moment.Moment;
  modified: moment.Moment;
}

export class AssociationModel {
  id?: number;
  name: string;
  isEnabled: boolean;
  about: string;
  logo: string;
  created: moment.Moment;
  modified: moment.Moment;

  constructor() {
    this.isEnabled = true;
  }

  static fromObject(association: IAssociationModel): AssociationModel {
    let obj = new AssociationModel();
    obj.id = association.id;
    obj.name = association.name;
    obj.isEnabled = association.is_enabled;
    obj.about = association.about;
    obj.logo = association.logo;
    obj.created = moment(association.created);
    obj.modified = moment(association.modified);
    return obj;
  }

  static fromObjectArray(associations: IAssociationModel[]): AssociationModel[] {
    return associations.map((association: IAssociationModel) => AssociationModel.fromObject(association));
  }
}

export interface IResultAssociationModel {
  count: number;
  next: string;
  previous: string;
  results: IAssociationModel[];
}

export class ResultAssociationModel {
  count: number = 0;
  next: string;
  previous: string;
  results: AssociationModel[] = [];

  constructor() {
    this.count = 0;
  }

  static fromObject(result: IResultAssociationModel): ResultAssociationModel {
    let obj = new ResultAssociationModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? AssociationModel.fromObjectArray(result.results) : [];
    return obj;
  }
}
